import { RoleDTO } from '../../http/dtos/roles/rolesDTO';
import httpClient from '../../http/httpClient';

export const rolesRepository = {
    GetRolesList: () => {
        return httpClient.get('/roles').then((response: RoleDTO[]) => response);
    },
};
